/*
 *
 * Package: `@dbh/app`.
 *
 */const importApp=import('./component-cf244ae1.js'/*  webpackChunkName: 'dbh.app.component' */);const importAppSsr=import('./ssr-f934d4be.js'/*  webpackChunkName: 'dbh.app.ssr' */);

export { importApp, importAppSsr };
